const readFirstDefined = (source, keys) => {
  if (!source) return null;
  const key = keys.find((item) => source[item] !== undefined && source[item] !== null);
  return key ? source[key] : null;
};

export const normaliseAutomationFlowStatus = (flow) => {
  const status = readFirstDefined(flow, ["is_active"]);
  const normalisedStatus = typeof status === "string" ? status.trim().toLowerCase() : status;

  if (normalisedStatus === true || normalisedStatus === 1 || normalisedStatus === "1" || normalisedStatus === "true") {
    return "active";
  }

  if (normalisedStatus === false || normalisedStatus === 0 || normalisedStatus === "0" || normalisedStatus === "false") {
    return "inactive";
  }

  return "inactive";
};

export const isActiveAutomationFlow = (flow) => {
  const status = normaliseAutomationFlowStatus(flow);
  return status === "active";
};
